import { BaseEntityModel } from '/@/modules/core/app/models/abstracts/BaseEntityModel';
import { ModelType } from '/@/modules/core/app/constants/ModelType';
import { DocumentCollection } from '@/modules/document/models/DocumentCollection';
import { Estate } from '@/modules/estate/models/Estate';
import { Will } from '@/modules/will/models/Will';

export class Codicil extends BaseEntityModel {
  id?: number;
  estateId?: number;
  willId?: string;
  datedAt?: string;
  documents: Relationship<DocumentCollection>;
  estate?: Relationship<Estate | null>;
  will?: Relationship<Will | null>;

  constructor(model: Partial<Codicil> = {}) {
    super(model);

    this.id = model.id;
    this.estateId = model.estateId;
    this.willId = model.willId;
    this.datedAt = model.datedAt;

    this.documents = DocumentCollection.mapModel(model.documents);
    this.estate = Estate.mapModelOrNull(model.estate);
    this.will = Will.mapModelOrNull(model.will);
  }

  getModelName(): ModelType {
    return ModelType.CODICIL;
  }

  get documentUrl(): string | undefined {
    return this.documents?.codicilDocument?.url;
  }

  get documentName(): string | undefined {
    return this.documents?.codicilDocument?.name;
  }
}
